import { Checkbox } from "@mui/material";
import React from "react";

const CheckBox = React.forwardRef(({ className = "", ...props }, ref) => {
  return <Checkbox ref={ref} className={`custom-checkbox ${className}`} disableRipple {...props} />;
});

export default CheckBox;
